import React from 'react';
import { Dropdown ,Icon , Menu , Segment } from 'semantic-ui-react'
import { Link } from 'react-router-dom'  

import auth0Client from './Auth/Auth';

import escudo from './../assets/img/escudo.png';
import './../assets/eje.css';

export default class MenuApp extends React.Component {
  
    constructor(props) {
        super(props);
        
        this.state = {
          optionsMenu : null,
          collapsed: true,
          logged :  true 
        };

        this.loadMenuFromClaims = this.loadMenuFromClaims.bind(this);

    }

    completarMenuDemo(){
     
      let itemsMenu = [];

      itemsMenu = [
        {"orden":0,"descripcion":"Lista de Expedientes","enlaceWeb":"/listaAnalisis",       "icono":"folder open","adTitulo":"listaAnalisis","flagPrincipal":1,"idOperacion":137,"idOpeSup":0, "adIcono":"","adDescripcion":""},
        {"orden":0,"descripcion":"Base de Conocimientos","enlaceWeb":"/baseDeConocimientos","icono":"sitemap","adTitulo":"baseDeConocimientos","flagPrincipal":1,"idOperacion":702,"idOpeSup":0,"adIcono":"","adDescripcion":""},
        {"orden":0,"descripcion":"Feriados",            "enlaceWeb":"/feriados",            "icono":"calendar alternate outline","adTitulo":"feriados","flagPrincipal":0,"idOperacion":138,"idOpeSup":702 ,"adIcono":"","adDescripcion":""},
        {"orden":0,"descripcion":"Magistrados",         "enlaceWeb":"/magistrados",         "icono":"users","adTitulo":"magistrados","flagPrincipal":0,"idOperacion":139,"idOpeSup":702 ,"adIcono":"","adDescripcion":""},
        {"orden":0,"descripcion":"Plantillas",          "enlaceWeb":"/plantillas",          "icono":"folder open outline","adTitulo":"plantillas","flagPrincipal":0,"idOperacion":140,"idOpeSup":702 ,"adIcono":"","adDescripcion":""},
        {"orden":0,"descripcion":"Config. Importación","enlaceWeb":"/configImp",            "icono":"archive","adTitulo":"configImp","flagPrincipal":0,"idOperacion":141,"idOpeSup":702 ,"adIcono":"","adDescripcion":""}
      ];

      this.setState({
        optionsMenu: itemsMenu 
      });
  
    }

    componentDidMount(){
      this.loadMenuFromClaims();
      //this.completarMenuDemo();
    }

    loadMenuFromClaims(){
      let METHODNAME = 'loadMenuFromClaims - ';
      console.log( METHODNAME + 'INI ');
      /*
      // [
          {
              "orden":0,
              "descripcion":"INICIO",
              "flagPrincipal":1,
              "idOperacion":137,
              "idOpeSup":0,
              "enlaceWeb":"/inicio",
              "icono":"pe-7s-home",
              "adTitulo":"",
              "adIcono":"",
              "adDescripcion":""
          },
          {"orden":0,"descripcion":"PERSONAL","flagPrincipal":1,"idOperacion":702,"idOpeSup":0,"enlaceWeb":"-","icono":"pe-7s-user","adTitulo":"","adIcono":"","adDescripcion":""},
          {"orden":0,"descripcion":"Ver Marcaciones","flagPrincipal":0,"idOperacion":138,"idOpeSup":702,"enlaceWeb":"/marcaciones","icono":"pe-7s-angle-right","adTitulo":"","adIcono":"","adDescripcion":""},
          {"orden":0,"descripcion":"Ver Papeletas","flagPrincipal":0,"idOperacion":139,"idOpeSup":702,"enlaceWeb":"/papeletas","icono":"pe-7s-angle-right","adTitulo":"","adIcono":"","adDescripcion":""},
          {"orden":0,"descripcion":"Boletas de Pago","flagPrincipal":0,"idOperacion":140,"idOpeSup":702,"enlaceWeb":"/boletas","icono":"pe-7s-angle-right","adTitulo":"","adIcono":"","adDescripcion":""},
          {"orden":0,"descripcion":"Otras Salidas","flagPrincipal":0,"idOperacion":141,"idOpeSup":702,"enlaceWeb":"/salidas","icono":"pe-7s-angle-right","adTitulo":"","adIcono":"","adDescripcion":""},
          {"orden":0,"descripcion":"Cargar Labores","flagPrincipal":0,"idOperacion":164,"idOpeSup":702,"enlaceWeb":"/labores","icono":"pe-7s-angle-right","adTitulo":"","adIcono":"","adDescripcion":""},
          {"orden":0,"descripcion":"Pagos en Efectivo","flagPrincipal":0,"idOperacion":172,"idOpeSup":702,"enlaceWeb":"/bandeja","icono":"pe-7s-angle-right","adTitulo":"","adIcono":"","adDescripcion":""}
      ]
      */

      if( this.state.optionsMenu === null ){
        let menuOption =  JSON.parse ( localStorage.getItem('operaciones') );
       
        menuOption.forEach(obj => {
          
          Object.entries(obj).forEach(([key, value]) => {
             // console.log(`${key} ${value}`);
          });
          
        });
        
        this.setState({
          optionsMenu: menuOption 
        });
      }else{
        console.log('menu creado');
      }

    }

    render() {

      const { optionsMenu } = this.state;

        return (
          <div>
         
          <Menu stackable>

            <Menu.Item as={ Link } name='root' to='/inicio'> 
              <img alt="EJE-Experto" src={escudo} /> 
            </Menu.Item>

            { optionsMenu && optionsMenu.map( item => (

              <Menu.Item as={ Link } name={item.adTitulo} to={item.enlaceWeb} >
                <Icon name={item.icono} />
                {item.descripcion}
              </Menu.Item>

            ))} 

            <Menu.Item name='feriados' onClick={auth0Client.closeSession} >
              <Icon name='log out' />
              Logout
            </Menu.Item>
  
          </Menu>
         
        </div>
        );
    }
}